import type { ReactNode } from 'react';

interface SectionCardProps {
  title: string;
  hint?: string;
  span?: 4 | 6 | 8 | 12;
  bodyClassName?: string;
  className?: string;
  children: ReactNode;
}

export const SectionCard = ({
  title,
  hint,
  span = 12,
  bodyClassName,
  className,
  children,
}: SectionCardProps) => (
  <section className={['section-card', `col-${span}`, className].filter(Boolean).join(' ')}>
    <header>
      <h3>{title}</h3>
      {hint && <span>{hint}</span>}
    </header>
    <div className={['body', bodyClassName].filter(Boolean).join(' ')}>{children}</div>
  </section>
);
